import {
  CssBaseline as MuiCssBaseline,
  CssBaselineProps as MuiCssBaselineProps,
} from '@mui/material';
import * as React from 'react';
import GlobalUnifyStyles from 'src/styles/themes/default/GlobalUnifyStyles';

/**
 * Injects global `<style>` tags into the document to provide consistent global CSS var based
 * styling for the Unify system.
 *
 * Only nest one of these inside a single `UnifyThemeProvider` on the page at a time!
 */
export const CssBaseline: React.FC<MuiCssBaselineProps> = ({ children }) => {
  return (
    <>
      <MuiCssBaseline enableColorScheme={true}>{children}</MuiCssBaseline>
      <GlobalUnifyStyles />
    </>
  );
};

export default CssBaseline;
export type { CssBaselineProps } from '@mui/material';
